export default function Logo() {
  return <h1>🏝️ Putovanje 🧳</h1>;
}
